import React, { useContext } from 'react'
import { Nav, NavLink } from '../../assets/styled'
import { UserContext } from '../../context/users/UserContext'

export default function Header() {
	const ctx = useContext(UserContext)

	const { logout, authStatus, isAdmin, isVerifying } = ctx

	if (isVerifying && !authStatus) {
		return (
			<div>
				<Nav>
					<span style={{ color: 'white', padding: '10px 15px' }}>Cargando...</span>
				</Nav>
			</div>
		)
	}

	return (
		<div>
			{authStatus ? (
				<Nav>
					<NavLink to='/alumnos'>Alumnos</NavLink>
					<NavLink to='/asistencia'>Asistencia</NavLink>
					{isAdmin ? <NavLink to='/pagos'>Pagos</NavLink> : null}
					<NavLink to='/' onClick={logout}>
						Cerrar sesión
					</NavLink>
				</Nav>
			) : (
				<Nav>
					<NavLink to='/iniciar-sesion'>Iniciar sesión</NavLink>
				</Nav>
			)}
		</div>
	)
}
